<script setup>
  import ReportBuilderV2 from "@/components/Reports/ReportBuilderV2/ReportBuilderV2.vue";
</script>

<template>
  <ReportBuilderV2 />
</template>
